import { Observable, BehaviorSubject } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { Component, OnInit, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import type { LatestTask } from '@fitness-force/models';
import { TourOutcomeComponent } from '../../../out-come/tour-outcome/tour-outcome.component';
import { CallOutcomeComponent } from '../../../out-come/call-outcome/call-outcome.component';

@Component({
  selector: 'track-status',
  templateUrl: './track-status.component.html',
  standalone: true,
  imports: [
    ButtonModule,
    RippleModule,
    StyleClassModule,
    TourOutcomeComponent,
    CallOutcomeComponent,
    AsyncPipe,
  ],
})
export class TrackStatusComponent implements OnInit {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  readonly onAction = output();
  readonly showClientAction = output();

  showMeetingOutcomePopup: Observable<boolean> | any = false;
  showCallOutcomePopup: Observable<boolean> | any = false;
  outcomeDetail: any = {};
  showClientSidebar = false;
  activeClientId = 0;

  constructor() {}

  ngOnInit(): void {}

  SetOutComeDetails(task: any) {
    const outcomeDetails: any = {};
    const latestTask: LatestTask = {} as LatestTask;
    latestTask.category_id = task.category_id;
    latestTask.name_primary_language = task.name_primary_language;
    latestTask.name_secondary_language = task.name_secondary_language;
    latestTask.priority = task.priority;
    latestTask.scheduled_date = task.scheduled_date;
    latestTask.status = task.status;
    latestTask.title = task.title;
    latestTask.type = task.type;
    latestTask.id = task.id;

    outcomeDetails.id = 0;
    outcomeDetails.company_id = task.company_id;
    outcomeDetails.tenant_id = task.tenant_id;
    outcomeDetails.client_info = task.client_info;

    outcomeDetails.service_type = [];
    if (task.oppportunity_info) {
      outcomeDetails.board_type = task.oppportunity_info.board_type;
      outcomeDetails.hot_warm_cold = task.oppportunity_info.hot_warm_cold;
      outcomeDetails.expected_closure_date =
        task.oppportunity_info.expected_closure_date;
      outcomeDetails.id = task.oppportunity_info.id;
      outcomeDetails.stage_master_id = task.oppportunity_info.stage_master_id;
      outcomeDetails.value_in_minor_currency =
        task.oppportunity_info.value_in_minor_currency;
      outcomeDetails.service_type = task.oppportunity_info.service_type;
      outcomeDetails.name = task.oppportunity_info.name;
    }
    outcomeDetails.assigned_to_staff_id = task.assigned_to_staff_id;
    outcomeDetails.comments = '';
    outcomeDetails.latest_task = latestTask;
    this.outcomeDetail = outcomeDetails;
    if (task.type.toLowerCase() == 'tour') {
      this.showMeetingOutcomePopup = true;
    } else {
      this.showCallOutcomePopup = true;
    }
  }

  HideOutComePopup(event: any) {
    this.showCallOutcomePopup = false;
    this.showMeetingOutcomePopup = false;
    this.onActionEvent(event);
  }

  onActionEvent(event: any) {
    this.onAction.emit(event);
  }

  GoToClientDetails(event: any) {
    this.onActionEvent({ action: 'showProfile', clientId: event.clientId });
  }
}
